export default __webpack_public_path__ + "static/media/NutOutYourNutrition.19560b0c.jpg";